import { signIn } from "@infinitaslearning/il.authentication.avatar"
import type { Language } from "@infinitaslearning/il.authentication.avatar"
import { getBusinessUnit } from "../utils/business.utils"

import "./identity-login.styles.scss"

const loginWithIdp = (): boolean => {
  const opco = getBusinessUnit()
  return opco === "Noordhoff" || opco === "Plantyn" || window.location?.search?.includes("enableIdp")
}

export type IdentityLoginConfig = {
  image: string
  logo: string
  loginUrl?: string
  clientId: string
  scope: string
  idpUrl: string
  isSSODisabled?: boolean
  language?: Language
  externalLogin: {
    plantyn: string
    liber: string
  }
}
type IdentityLoginProps = {
  config: IdentityLoginConfig
}
export const IdentityLogin = ({ config }: IdentityLoginProps) => {
  if (loginWithIdp()) {
    signIn(config)
    return null
  }
  /*
   * The user is always logged in via the Idp, but for Liber or Plantyn users the users
   * are logged in via an external login provider. In case the user logs out redirect in those
   * cases to an eternal login provider. The standard LoginContainer does not allow
   * the login action and the help links to be overriden. To overcome this this component
   * wraps that container and mimicks its appearance in those cases.
   */

  window.location.href = config.externalLogin.liber
  return null
}
